/* eslint-disable capitalized-comments */
import { RouterProvider } from 'react-router-dom';
import { NotificationProvider as CTNNNotificationProvider } from '@ctn/ui/components/ctn-notifications';
import { NotificationProvider, StrapiProvider } from '@/context';
import { router } from '@/routes';
import 'yet-another-react-lightbox/styles.css';
import '@ctn/ui/components/ctn-styles/styles.scss';
import '@/assets/theme/theme.scss';
import '@/styles/styles.scss';

function App() {
	return (
		<StrapiProvider>
			<CTNNNotificationProvider>
				<NotificationProvider>
					<RouterProvider router={router} />
				</NotificationProvider>
			</CTNNNotificationProvider>
		</StrapiProvider>
	);
}

export default App;
